import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import {
    backendBaseURL,
    apiAuthBaseURL,
    apiBaseURL,
    coreAPIBaseURL,
    suppliersAPIBaseURL,
    condoAdministratorAPIBaseURL,
    quotationAPIBaseURL,
    subscriptionHeaderApiBaseURL,
    contactNetworkAPIBaseURL,
    opportunitiesAPIBaseURL,
    paymentApiBaseURL,
    surveyMonkeyAPIBaseURL,
    notificationsAPIBaseURL,
    magicLinkAPIBaseURL,
    transactionsAPIBaseURL,
    marketingAPIBaseURL,
    engelinkCreditAPIBaseURL
} from '@/utils/end-points';
import VueCookies from 'vue-cookies';
import Vue from 'vue';
// Registro de Cookies
Vue.use(VueCookies);

export const headerAxios = () => {
    const key =
        Vue.$cookies.get('user') && Vue.$cookies.get('user').key != undefined ? Vue.$cookies.get('user').key : false;
    let config = {};
    if (key) {
        config = {
            Authorization: `Token ${key}`
        };
    }

    return config;
};

export const headerCondoAdministrator= () => {
    const key = Vue.$cookies.get('tk')
    let config = {};
    if (key) {
        config = {
            Authorization: `Token ${key}`
        };
    }
    return config;
};

export const postFormHeader = () => {
    return {
        'Content-Type': 'multipart/form-data'
    };
};
export const authConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: apiAuthBaseURL
        })
    );
export const notificationsConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: notificationsAPIBaseURL
        })
    );
export const paymentConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: paymentApiBaseURL
        })
    );

export const supplyConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: suppliersAPIBaseURL
        })
    );

export const administratorConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: condoAdministratorAPIBaseURL
        })
    );

export const quotationConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: quotationAPIBaseURL
        })
    );

export const subscriptionHeaderConfigAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: subscriptionHeaderApiBaseURL
        })
    );

export const configAxios = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: apiBaseURL
        })
    );

export const configAxiosBaseBufferArray = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            responseType: 'blob',
            baseURL: backendBaseURL
        })
    );

export const configAxiosNoCamelCase = () =>
    axios.create({
        headers: headerAxios(),
        baseURL: apiBaseURL
    });

export const configAxiosNoCamelCase2 = () =>
    axios.create({
        headers: headerCondoAdministrator(),
        baseURL: apiBaseURL
    });

export const configAxiosBase = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: backendBaseURL
        })
    );

export const configAxiosCore = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: coreAPIBaseURL
        })
    );

export const configAxiosContactNetwork = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: contactNetworkAPIBaseURL
        })
    );

export const configAxiosContactNetworkBlob = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            responseType: 'blob',
            baseURL: contactNetworkAPIBaseURL
        })
    );

export const configAxiosFormData = url =>
    axios.create({
        headers: postFormHeader(),
        baseURL: url
    });

export const configAxiosOpportunities = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: opportunitiesAPIBaseURL
        })
    );

export const configAxiosInvite = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: surveyMonkeyAPIBaseURL
        })
    );

export const configAxiosMagicLink = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: magicLinkAPIBaseURL
        })
    );

export const configAxiosExtract = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: `${backendBaseURL}extracts/extracts`
        })
    );

export const configAxiosTransactions = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: transactionsAPIBaseURL
        })
    );

export const configAxiosCampaign = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: marketingAPIBaseURL
        })
    );

export const configAxiosEngelinkCredit = () =>
    applyCaseMiddleware(
        axios.create({
            headers: headerAxios(),
            baseURL: engelinkCreditAPIBaseURL
        })
    );

export const successResponse = (res) => res;

export const errorResponse = (err) => {
    if (
        err.response.status === 401
    ) {
        window.location = '/entrar';
    } else {
        return Promise.reject(err);
    }
};